import debug from 'debug'

export function getLogger(name: string): debug.Debugger {
  return debug(`nm:${name}`)
}
